import { useEffect, useState } from "react";
import { toast } from "sonner";
import { TopBar } from "@/components/TopBar";
import { getUsers, setUserRole } from "@/lib/api";
import { useMe } from "@/components/auth/RequireAuth";

const ROLE_LABEL = { admin: "Administrador", member: "Utilizador" };

export default function Users() {
  const me = useMe();
  const [data, setData] = useState(null);
  useEffect(() => { getUsers().then(setData).catch(() => setData({ roles: [], users: [] })); }, []);

  const change = async (uid, role) => {
    const ok = await setUserRole(uid, role).catch(() => null);
    if (!ok) return;
    setData((d) => ({ ...d, users: d.users.map((u) => (u.user_id === uid ? { ...u, role } : u)) }));
    toast.success("Função atualizada");
  };

  return (
    <div className="relative z-10">
      <TopBar />
      <main className="max-w-7xl mx-auto px-3 sm:px-8 py-8 sm:py-14">
        <p className="label-caps mb-3">Administração</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold uppercase mb-8">Utilizadores</h1>
        {me.role !== "admin" ? <p data-testid="users-forbidden" className="text-zinc-500">Sem permissão.</p> : (
          <ul data-testid="users-list" className="border-y border-white/10 divide-y divide-white/10">
            {data?.users.map((u) => (
              <li key={u.user_id} data-testid={`user-row-${u.user_id}`} className="flex flex-wrap items-center gap-4 py-4">
                <div className="flex-1 min-w-0">
                  <p className="font-semibold truncate">{u.email || "—"}{u.user_id === me.user_id && <span className="text-zinc-500"> (você)</span>}</p>
                  <p className="text-sm text-zinc-500">{u.matches} {u.matches === 1 ? "jogo" : "jogos"}</p>
                </div>
                <select data-testid={`user-role-${u.user_id}`} value={u.role} onChange={(e) => change(u.user_id, e.target.value)}
                  className="h-11 bg-[#0A0A0A] border border-white/15 px-3 focus:outline-none focus:border-[#CCFF00]">
                  {data.roles.map((r) => <option key={r} value={r}>{ROLE_LABEL[r] || r}</option>)}
                </select>
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
